// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hidden {
  margin-left: -200px;
}

a[data-toggle='collapse'] {
  position: relative;
}

@media (max-width: 575px) {
  .hidden {
    margin-left: 0;
  }
}

.sidebar-header {
  padding: 20px;
}

ul li a {
  padding: 15px;
  display: flex;
  width: 100%;
}

hr {
  border-top: 1px solid #fff;
  margin-top: 0;
}
/**tabbar left navigation starts**/

li {
  display: block;
}
li > a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #222b45;
  border-bottom: 1px solid #edf1f7;
  position: relative;
  font-family: 'montserratregular', Arial, Helvetica, sans-serif;
  font-weight: normal;
  padding: 14px 25px 14px 5px;
}
li:last-child > a {
  border-bottom-color: transparent;
}
li:hover > a,
li:hover > a > i {
  color: #36f;
  cursor: pointer;
}
li > a.active,
li > a.active > i {
  color: #36f;
}
li > a.active::before {
  content: '';
  width: 3px;
  height: 100%;
  background-color: #7f8dff;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
}
li > a > i {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  margin-right: 10px;
  width: 40px;
  color: #828c9f;
}
li:hover ul {
  background-color: rgba(0, 0, 0, 0.01);
}
li.hasSubMenu > a:after {
  content: '\\e908';
  display: inline-block;
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  font-family: 'icomoon';
  font-weight: normal;
  font-size: 0.7rem;
  transition: all 0.2s ease-out;
}

li.hasSubMenu > a.selected:after {
  content: '\\f078';
  display: inline-block;
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  font-family: 'FontAwesome';
  font-weight: normal;
  font-size: 0.7rem;
  transition: all 0.2s ease-out;
}

li.hasSubMenu > a.activeTab:after {
  transform: translateY(-50%) rotate(90deg);
}
li.hasSubMenu > ul li {
  padding: 0;
}
li.hasSubMenu > ul li > a {
  padding-left: 20px;
  color: #617d95;
}
li.hasSubMenu > ul li > a:hover {
  color: #36f;
}
li.hasSubMenu > ul > li.hasSubMenu > ul {
  position: fixed;
  top: 400px;
  left: 235px;
  z-index: 99;
  box-shadow: 0 7px 18px -8px #000;
  -webkit-box-shadow: 0 7px 18px -8px #000;
  -moz-box-shadow: 0 7px 18px -8px #000;
  background-color: #fff;
  overflow: hidden;
  overflow-y: auto;
}
li.hasSubMenu > ul > li.hasSubMenu > ul > li > a {
  color: #153d77;
}
li.hasSubMenu > ul > li.hasSubMenu > ul.active {
  display: block;
  background-color: #f2f2f2;
}
.menuClosed .leftNav {
  margin-left: -250px;
}
.menuClosed .leftNav {
  min-width: 10px !important;
  width: 60px !important;
  overflow-x: hidden;
  transition: width 0.3s ease;
}
.leftNavActionbar {
  height: 45px;
  overflow: hidden;
  position: relative;
  z-index: 2;
}
.leftNavActionbar a {
  background-color: #8f9bb3;
  color: #fff;
  padding: 10px 15px;
  height: 45px;
  display: flex;
  width: 100%;
}
/**tabbar left navigation ends**/

@media (max-width: 767px) {
  .leftNav {
    position: fixed;
    top: 50px;
    z-index: 98;
    height: calc(100% - 50px);
  }
}
@media (max-width: 960px) {
  li > a > span {
    display: block;
    font-size: 0.9rem;
    text-wrap: balance;
    text-overflow: clip;
    white-space: pre-wrap;
    overflow: hidden;
    line-height: 1rem;
  }
}
.btnToggleBlock {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 10px;
  color: #ffffff;
  cursor: pointer;
  z-index: 2;
  font-size: 0.6rem;
}

.profileContent .block > h4 {
  border-bottom: none !important;
  padding-bottom: 0px !important
   ;
}

.leftNav .userSetting ul.lnUl li > a {
  border-bottom: 1px solid;
  border-image-slice: 1;
  border-width: 1px;
  border-image-source: linear-gradient(to left, #1bd2f7, #c0eef7);
}

.signout {
  background: linear-gradient(to left, #1bd2f7, #c0eef7);
}
@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {
  .leftNav {
    width: 170px;
  }
}

li.hasSubMenu > ul li ul li > a {
  padding-left: 38px !important;
}

li.hasSubMenu > ul li ul li > a > span,
li.hasSubMenu > ul li ul li > a > i {
  font-size: 0.85rem;
}

.badge1 {
  animation: 0.5s cubic-bezier(0.5, 0, 1, 1) infinite alternate blinker;
  content: attr(data-badge);
  position: absolute;
  top: 5px;
  left: 15px;
  font-size: 0.7em;
  background-color: #36f;
  color: #fff;
  width: 18px;
  height: 18px;
  text-align: center;
  line-height: 18px;
  border-radius: 50%;
  box-shadow: 0 0 1px #333;
}

.badge-info {
  color: #23282c;
  background-color: #63c2de;
  font-size: 0.6rem !important;
  font-weight: 100;
  overflow: visible !important;
}

.imgsrc {
  width: 20%;
}

.badge {
  color: #fff;
  width: 12%;
  background-color: #2a62ff;
}
`, "",{"version":3,"sources":["webpack://./src/app/home/menu-item-home/menu-item-home.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;AACA,kCAAkC;;AAElC;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,8DAA8D;EAC9D,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,WAAW;AACb;AACA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;AAC3C;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA,gCAAgC;;AAEhC;EACE;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B;GACC;AACH;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,+DAA+D;AACjE;;AAEA;EACE,sDAAsD;AACxD;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EAEE,qEAAqE;EACrE,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;EACV,yBAAyB;AAC3B","sourcesContent":[".hidden {\n  margin-left: -200px;\n}\n\na[data-toggle='collapse'] {\n  position: relative;\n}\n\n@media (max-width: 575px) {\n  .hidden {\n    margin-left: 0;\n  }\n}\n\n.sidebar-header {\n  padding: 20px;\n}\n\nul li a {\n  padding: 15px;\n  display: flex;\n  width: 100%;\n}\n\nhr {\n  border-top: 1px solid #fff;\n  margin-top: 0;\n}\n/**tabbar left navigation starts**/\n\nli {\n  display: block;\n}\nli > a {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  color: #222b45;\n  border-bottom: 1px solid #edf1f7;\n  position: relative;\n  font-family: 'montserratregular', Arial, Helvetica, sans-serif;\n  font-weight: normal;\n  padding: 14px 25px 14px 5px;\n}\nli:last-child > a {\n  border-bottom-color: transparent;\n}\nli:hover > a,\nli:hover > a > i {\n  color: #36f;\n  cursor: pointer;\n}\nli > a.active,\nli > a.active > i {\n  color: #36f;\n}\nli > a.active::before {\n  content: '';\n  width: 3px;\n  height: 100%;\n  background-color: #7f8dff;\n  z-index: 2;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\nli > a > i {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.5rem;\n  margin-right: 10px;\n  width: 40px;\n  color: #828c9f;\n}\nli:hover ul {\n  background-color: rgba(0, 0, 0, 0.01);\n}\nli.hasSubMenu > a:after {\n  content: '\\e908';\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n  right: 15px;\n  transform: translateY(-50%);\n  font-family: 'icomoon';\n  font-weight: normal;\n  font-size: 0.7rem;\n  transition: all 0.2s ease-out;\n}\n\nli.hasSubMenu > a.selected:after {\n  content: '\\f078';\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n  right: 15px;\n  transform: translateY(-50%);\n  font-family: 'FontAwesome';\n  font-weight: normal;\n  font-size: 0.7rem;\n  transition: all 0.2s ease-out;\n}\n\nli.hasSubMenu > a.activeTab:after {\n  transform: translateY(-50%) rotate(90deg);\n}\nli.hasSubMenu > ul li {\n  padding: 0;\n}\nli.hasSubMenu > ul li > a {\n  padding-left: 20px;\n  color: #617d95;\n}\nli.hasSubMenu > ul li > a:hover {\n  color: #36f;\n}\nli.hasSubMenu > ul > li.hasSubMenu > ul {\n  position: fixed;\n  top: 400px;\n  left: 235px;\n  z-index: 99;\n  box-shadow: 0 7px 18px -8px #000;\n  -webkit-box-shadow: 0 7px 18px -8px #000;\n  -moz-box-shadow: 0 7px 18px -8px #000;\n  background-color: #fff;\n  overflow: hidden;\n  overflow-y: auto;\n}\nli.hasSubMenu > ul > li.hasSubMenu > ul > li > a {\n  color: #153d77;\n}\nli.hasSubMenu > ul > li.hasSubMenu > ul.active {\n  display: block;\n  background-color: #f2f2f2;\n}\n.menuClosed .leftNav {\n  margin-left: -250px;\n}\n.menuClosed .leftNav {\n  min-width: 10px !important;\n  width: 60px !important;\n  overflow-x: hidden;\n  transition: width 0.3s ease;\n}\n.leftNavActionbar {\n  height: 45px;\n  overflow: hidden;\n  position: relative;\n  z-index: 2;\n}\n.leftNavActionbar a {\n  background-color: #8f9bb3;\n  color: #fff;\n  padding: 10px 15px;\n  height: 45px;\n  display: flex;\n  width: 100%;\n}\n/**tabbar left navigation ends**/\n\n@media (max-width: 767px) {\n  .leftNav {\n    position: fixed;\n    top: 50px;\n    z-index: 98;\n    height: calc(100% - 50px);\n  }\n}\n@media (max-width: 960px) {\n  li > a > span {\n    display: block;\n    font-size: 0.9rem;\n    text-wrap: balance;\n    text-overflow: clip;\n    white-space: pre-wrap;\n    overflow: hidden;\n    line-height: 1rem;\n  }\n}\n.btnToggleBlock {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 6px 10px;\n  color: #ffffff;\n  cursor: pointer;\n  z-index: 2;\n  font-size: 0.6rem;\n}\n\n.profileContent .block > h4 {\n  border-bottom: none !important;\n  padding-bottom: 0px !important\n   ;\n}\n\n.leftNav .userSetting ul.lnUl li > a {\n  border-bottom: 1px solid;\n  border-image-slice: 1;\n  border-width: 1px;\n  border-image-source: linear-gradient(to left, #1bd2f7, #c0eef7);\n}\n\n.signout {\n  background: linear-gradient(to left, #1bd2f7, #c0eef7);\n}\n@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {\n  .leftNav {\n    width: 170px;\n  }\n}\n\nli.hasSubMenu > ul li ul li > a {\n  padding-left: 38px !important;\n}\n\nli.hasSubMenu > ul li ul li > a > span,\nli.hasSubMenu > ul li ul li > a > i {\n  font-size: 0.85rem;\n}\n\n.badge1 {\n  -webkit-animation: 0.5s cubic-bezier(0.5, 0, 1, 1) infinite alternate blinker;\n  animation: 0.5s cubic-bezier(0.5, 0, 1, 1) infinite alternate blinker;\n  content: attr(data-badge);\n  position: absolute;\n  top: 5px;\n  left: 15px;\n  font-size: 0.7em;\n  background-color: #36f;\n  color: #fff;\n  width: 18px;\n  height: 18px;\n  text-align: center;\n  line-height: 18px;\n  border-radius: 50%;\n  box-shadow: 0 0 1px #333;\n}\n\n.badge-info {\n  color: #23282c;\n  background-color: #63c2de;\n  font-size: 0.6rem !important;\n  font-weight: 100;\n  overflow: visible !important;\n}\n\n.imgsrc {\n  width: 20%;\n}\n\n.badge {\n  color: #fff;\n  width: 12%;\n  background-color: #2a62ff;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
